import '../css/search-filter-custom.css';
import { createApp, h } from 'vue';
import SearchFilterPopup from './components/SearchFilterPopup.vue';

function parseJson(value, fallback) {
    try {
        if (value === undefined || value === null || value === '') {
            return fallback;
        }

        return JSON.parse(value);
    } catch (error) {
        console.error('[search-filter] JSON parse failed:', error);
        return fallback;
    }
}

function boolLike(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

export function mountSearchFilterPopup(rootId = 'vue-search-filter') {
    const filterEl = document.getElementById(rootId);

    if (!filterEl || filterEl.dataset.mounted === '1') {
        return null;
    }

    filterEl.dataset.mounted = '1';

    const props = {
        context: filterEl.dataset.context || 'default',
        showTransaction: boolLike(filterEl.dataset.showTransaction),
        categoryTree: parseJson(filterEl.dataset.categoryTree, []),
        initialRoomOptions: parseJson(filterEl.dataset.initialRoomOptions, []),
        searchUrl: filterEl.dataset.searchUrl || '',
        requestParams: parseJson(filterEl.dataset.requestParams, {}),
        metadataBaseUrl: filterEl.dataset.categoryMetadataUrlBase || '',
        selectedMainCategoryId: filterEl.dataset.selectedMainCategoryId || '',
        selectedSubCategoryId: filterEl.dataset.selectedSubCategoryId || '',
        countUrl: filterEl.dataset.countUrl || '',
        locationSearchUrl: filterEl.dataset.locationSearchUrl || filterEl.dataset.locationPublishSearch || '',
        countriesUrl: filterEl.dataset.locCountries || filterEl.dataset.countriesUrl || '',
        citiesUrl: filterEl.dataset.locCities || filterEl.dataset.citiesUrl || '',
        districtsUrl: filterEl.dataset.locDistricts || filterEl.dataset.districtsUrl || '',
        neighborhoodsUrl: filterEl.dataset.locNeighborhoods || filterEl.dataset.neighborhoodsUrl || '',
    };

    if (!props.searchUrl) {
        console.warn('[search-filter] searchUrl is empty.');
    }

    const app = createApp({
        render: () => h(SearchFilterPopup, props),
    });

    app.mount(filterEl);

    return app;
}
